import home from './home.json'
import selectAccount from './selectAccount.json'
import logout from './logout.json'
import summary from './summary.json'
import placements from './placements.json'
import blackList from './blackList.json'
import whiteList from './whiteList.json'
import keywords from './keywords.json'
import settings from './settings.json'
import actionLog from './actionLog.json'
import actionLogPlacements from './actionLogPlacements.json'
import actionLogKeywords from './actionLogKeywords.json'
import actionLogAds from './actionLogAds.json'
import ads from './ads.json'
import error from './error.json'

export default {
  en: {
    home: home.en,
    selectAccount: selectAccount.en,
    logout: logout.en,
    summary: summary.en,
    placements: placements.en,
    blackList: blackList.en,
    whiteList: whiteList.en,
    keywords: keywords.en,
    settings: settings.en,
    actionLog: actionLog.en,
    actionLogPlacements: actionLogPlacements.en,
    actionLogKeywords: actionLogKeywords.en,
    actionLogAds: actionLogAds.en,
    ads: ads.en,
    error: error.en
  },
  ru: {
    home: home.ru,
    selectAccount: selectAccount.ru,
    logout: logout.ru,
    summary: summary.ru,
    placements: placements.ru,
    blackList: blackList.ru,
    whiteList: whiteList.ru,
    keywords: keywords.ru,
    settings: settings.ru,
    actionLog: actionLog.ru,
    actionLogPlacements: actionLogPlacements.ru,
    actionLogKeywords: actionLogKeywords.ru,
    actionLogAds: actionLogAds.ru,
    ads: ads.ru,
    error: error.ru
  }
};
